// extracted by mini-css-extract-plugin
export default {"certificate":"CertificatePart_certificate__b-kTv"};